import { render, staticRenderFns } from "./captureProperty.vue?vue&type=template&id=476818f4&scoped=true"
import script from "./captureProperty.ts?vue&type=script&lang=js&external"
export * from "./captureProperty.ts?vue&type=script&lang=js&external"
import style0 from "./captureProperty.vue?vue&type=style&index=0&id=476818f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476818f4",
  null
  
)

export default component.exports